import React, { createContext, useContext, useState } from "react";

export const DistributorAuthContext = createContext();

export const DistributorAuthProvider = ({ children }) => {
  const [distributor, setDistributor] = useState(() => {
    const storedDistributor = localStorage.getItem("distributor");
    return storedDistributor ? JSON.parse(storedDistributor) : null;
  });

  const logoutDistributor = () => {
    localStorage.removeItem("distributor");
    setDistributor(null);
  };

  return (
    <DistributorAuthContext.Provider value={{ distributor, setDistributor, logoutDistributor }}>
      {children}
    </DistributorAuthContext.Provider>
  );
};

export const useDistributorAuth = () => useContext(DistributorAuthContext);
